import {useApi} from "../Api";
import {GreenDiscountDetails, GreenDiscountEntityResponse, GreenDiscountUpdateDetails} from "../types/greenDiscount";
import {SelectElementModelBE} from "../types/generic";

export const useGreenDiscountDetailRepository = () => {
    const {GET, PUT} = useApi();

    const PATH = "/pricing/green-discount-rate-detail";
    const ACRISSPATH = "/pricing/acriss-fuel-type"

    function updateGreenDiscountMatrix(associationRequest: GreenDiscountUpdateDetails): Promise<GreenDiscountDetails[]> {
        return PUT(`${PATH}/update-price-matrix`, associationRequest);
    }

    function getGreenDiscountMatrix(greenDiscountId: GreenDiscountEntityResponse["id"]): Promise<GreenDiscountDetails[]> {
        return GET(`${PATH}/price-matrix?greenDiscountId=${greenDiscountId}`);
    }

    function getAcrissFuelType(): Promise<SelectElementModelBE[]> {
        return GET(`${ACRISSPATH}/list`);
    }

    return {
        updateGreenDiscountMatrix,
        getGreenDiscountMatrix,
        getAcrissFuelType
    };
};
